import ICrash from "@icrash/browser";
import { ICRASH_DSN, ICRASH_ENVIRONMENT, ICRASH_RELEASE } from "../config";

const redactText = (value) =>
	String(value || "")
		.replace(/(\/(?:reset-password|verify-email)\/)[^/?#\s)]+/gi, "$1[redacted]")
		.replace(/([?&#;](?:[^=&#]*(?:token|key|password|passwd|secret|auth|session|signature|code)[^=&#]*)=)[^&#\s]*/gi, "$1[redacted]")
		.replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, "[email]")
		.replace(/((?:bearer\s+|(?:token|password|passwd|secret|api[_-]?key)\s*[:=]\s*)["']?)[^\s"'&,]+/gi, "$1[redacted]");

const sanitizeEvent = (event) => {
	if (event.message) event.message = redactText(event.message);
	if (event.stack) event.stack = redactText(event.stack);
	delete event.user;
	delete event.extra;

	if (event.request) {
		if (event.request.url) event.request.url = redactText(event.request.url).split(/[?#]/, 1)[0];
		if (event.request.headers) {
			const userAgent = event.request.headers["User-Agent"] || event.request.headers["user-agent"];
			event.request.headers = userAgent ? { "User-Agent": userAgent } : {};
		}
		delete event.request.query;
	}
	if (event.http) {
		if (event.http.url) event.http.url = redactText(event.http.url).split(/[?#]/, 1)[0];
		if (event.http.path) event.http.path = redactText(event.http.path).split(/[?#]/, 1)[0];
	}
	if (Array.isArray(event.breadcrumbs)) {
		event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => ({
			...breadcrumb,
			message: breadcrumb.message ? redactText(breadcrumb.message) : breadcrumb.message,
			data: undefined,
		}));
	}
	if (Array.isArray(event.frames)) {
		event.frames = event.frames.map((frame) => ({
			...frame,
			file: frame.file ? redactText(frame.file) : frame.file,
			context_line: frame.context_line ? redactText(frame.context_line) : frame.context_line,
			pre_context: Array.isArray(frame.pre_context) ? frame.pre_context.map(redactText) : frame.pre_context,
			post_context: Array.isArray(frame.post_context) ? frame.post_context.map(redactText) : frame.post_context,
		}));
	}
	return event;
};

export const initCrashAnalytics = () => {
	if (!ICRASH_DSN || typeof window === "undefined") return;

	ICrash.init({
		dsn: ICRASH_DSN,
		environment: ICRASH_ENVIRONMENT,
		release: ICRASH_RELEASE,
		beforeSend: sanitizeEvent,
	});
	ICrash.setTag("application", "iecom-portal");

	const sdkConsoleError = console.error.bind(console);
	console.error = (...args) => {
		const error = args.find((arg) => arg instanceof Error);
		const status = Number(error?.response?.status);
		if (error && (!Number.isFinite(status) || status >= 500)) {
			ICrash.captureException(error, { mechanism: "console.error", handled: true });
		}
		return sdkConsoleError(...args);
	};
};
